import { render } from "./PackingHistory.vue?vue&type=template&id=23d0a05c&scoped=true"
import script from "./PackingHistory.vue?vue&type=script&lang=js"
export * from "./PackingHistory.vue?vue&type=script&lang=js"

import "./PackingHistory.vue?vue&type=style&index=0&id=23d0a05c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d0a05c"]])

export default __exports__